import PropTypes from "prop-types";
import { connect } from "react-redux";
import Newsletters from "components/v3/newsletters/Newsletters";
import newsletterActions from "ducks/newsletter";
import { getNewslettersById, sortByTitle } from "utils/newsletters";
import getFlatNewsletterList from "common/utils/getFlatNewsletterList";
import { setThinking, doneThinking } from "ducks/thinking";

const NEWSLETTER_TYPES = {
    subscribers: {
        DEFAULT: [ "Open Americas Natural", "Close Americas Natural" ],
        ASIA: [ "Open Asia Natural", "Close Asia Natural" ],
        EUROPE: [ "Open Europe Natural", "Close Europe Natural" ]
    },
    signup: {
        DEFAULT: [ "Business Daily", "Markets Daily", "technology" ]
    }
};

const COUNTRIES_PER_REGION = {
    ASIA: [ "HK", "AU", "SG", "MY", "TH", "ID", "IN", "PH", "JP" ],
    EUROPE: [ "GB", "AE", "ES", "DE", "BE", "ZA", "CH", "TR", "SA", "FR", "IT" ]
};

const OVERRIDE_NEWSLETTER_TITLE = {
    "Business Daily": "Bloomberg Business Daily",
    "Markets Daily": "Bloomberg Markets Daily",
    "Open Americas Natural": "The Bloomberg Open: Americas Edition",
    "Close Americas Natural": "The Bloomberg Close: Americas Edition",
    "Open Asia Natural": "The Bloomberg Open: Asia Edition",
    "Close Asia Natural": "The Bloomberg Close: Asia Edition",
    "Open Europe Natural": "The Bloomberg Open: Europe Edition",
    "Close Europe Natural": "The Bloomberg Close: Europe Edition"
};

function getRegionForCountry(country) {
    if (COUNTRIES_PER_REGION.ASIA.indexOf(country) !== -1) {
        return "ASIA";
    }

    if (COUNTRIES_PER_REGION.EUROPE.indexOf(country) !== -1) {
        return "EUROPE";
    }

    return "DEFAULT";
}

function filterNewsletters(newsletters, newsletterType, subscribedNewsletterIds, country) {
    const region = getRegionForCountry(country);
    const ids = NEWSLETTER_TYPES[newsletterType][region];
    const sortOrder = newsletterType === "signup" ? "ascending" : "descending";

    let newsletterData = getNewslettersById(newsletters, ids);

    newsletterData = newsletterData.map((newsletter) => {
        const listId = newsletter.listId || newsletter.list;

        newsletter.listId = listId;
        newsletter.subscribed = Boolean(subscribedNewsletterIds[listId]);
        newsletter.title = OVERRIDE_NEWSLETTER_TITLE[listId] || newsletter.title;

        return newsletter;
    });

    return sortByTitle(newsletterData, sortOrder);
}

function getAutoSubscriptions(type, country) {
    if (country !== "US") {
        return [];
    }

    const region = getRegionForCountry(country);
    const ids = NEWSLETTER_TYPES[type][region];

    return type === "signup" ? ids.filter((id) => id === "Business Daily") : ids;
}

export function updateAllSubscriptions(email, type, subscribe) {
    return (dispatch, getState) => {
        const listIds = getAutoSubscriptions(type, getState().country);

        if (listIds.length === 0) {
            return;
        }

        const updatedSubscriptions = listIds.reduce((allNewsletters, id) => {
            allNewsletters[id] = subscribe;

            return allNewsletters;
        }, {});

        dispatch(newsletterActions.startUpdatingNewsletterSubscription(updatedSubscriptions, email, { notify: false }));
    };
}

export function mapStateToProps(state, ownProps) {
    const {
        newsletter,
        thinking,
        country
    } = state;

    const { newsletterType } = ownProps;
    const {
        dailyNewsletters = [],
        weeklyNewsletters = [],
        subscribedNewsletterIds = {}
    } = newsletter;
    const newsletters = getFlatNewsletterList(dailyNewsletters.concat(weeklyNewsletters));
    const newsletterData = filterNewsletters(newsletters, newsletterType, subscribedNewsletterIds, country);

    return {
        newsletters: newsletterData,
        thinking
    };
}

export function mapDispatchToProps(dispatch, ownProps) {
    const { newsletterType, email } = ownProps;

    return {
        fetchNewsletterData() {
            dispatch(newsletterActions.startFetchingNewsletterData(email))
                .then(() => {
                    dispatch(updateAllSubscriptions(email, newsletterType, true));
                    dispatch(doneThinking());
                })
                .catch(() => dispatch(doneThinking()));
        },

        updateSubscription(newsletterId, status) {
            return dispatch(newsletterActions.startUpdatingNewsletterSubscription({
                [newsletterId]: status
            }, email));
        },

        setThinking() {
            dispatch(setThinking());
        }
    };
}

const NewslettersContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Newsletters);

NewslettersContainer.propTypes = {
    newsletterType: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
};

export default NewslettersContainer;
